export const ContactsTitles = {
  contacts: 'Contacts',
  telNumber: '+34 600 59 20 07',
  email: 'info@modernacasa.es',
  socialMedia: 'Social media',
  form: 'Form',
  name_placeholder: 'Name',
  email_placeholder: 'Email*',
  phone_placeholder: 'Phone number',
  description_placeholder: 'Description',
  send: 'Send',
}
